import styled from 'styled-components';

export const Container = styled.div`
  position: sticky;
  top: 80px;
  z-index: 99;
  display: flex;
  justify-content: flex-end;
`;
